"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Who is a patient (A7.1 contract §4).
 *
 * The primary signal is a top-level `IsPatient` boolean: on the login
 * `UserInfo` (patient verify, /login, /csrf) and on the GetMe user view.
 * Older payloads have no flag; then a user is a patient when it has at least
 * one non-pending relationship and every non-pending relationship has the
 * patient role. Requiring one non-pending relationship keeps a staff account
 * whose only relationship is a pending join request on the staff side. */

 const PATIENT_ROLE = 'patient'; exports.PATIENT_ROLE = PATIENT_ROLE




















const everyActiveRoleIsPatient = (roles) => {
  const active = roles.filter(r => !r.pending)
  return active.length > 0 && active.every(r => r.role === exports.PATIENT_ROLE)
}

const relationshipRoles = (rels) =>
  Object.values(rels || {}).map(r => ({ role: _nullishCoalesce(r.RelType, () => ( r.Type)), pending: !!r.Pending }))

 const isPatientLogin = (payload) => {
  const userInfo = _optionalChain([payload, 'optionalAccess', _ => _.UserInfo])
  if (typeof _optionalChain([userInfo, 'optionalAccess', _2 => _2.IsPatient]) === 'boolean') return userInfo.IsPatient
  if (typeof _optionalChain([payload, 'optionalAccess', _3 => _3.User, 'optionalAccess', _4 => _4.IsPatient]) === 'boolean') return payload.User.IsPatient

  if (_optionalChain([userInfo, 'optionalAccess', _5 => _5.Organizations, 'optionalAccess', _6 => _6.length])) {
    return everyActiveRoleIsPatient(userInfo.Organizations.map(o => ({
      role: o.Role,
      pending: !!o.PendingRelationship,
    })))
  }
  return everyActiveRoleIsPatient(relationshipRoles(_optionalChain([payload, 'optionalAccess', _7 => _7.User, 'optionalAccess', _8 => _8.Relationships])))
}; exports.isPatientLogin = isPatientLogin

/* GetMe's user view: the flag, or `Relationships[org].RelType`. Undefined when
 * the view has neither, so the caller can keep the login answer. */
 const isPatientMe = (
  me,
) => {
  if (!me) return undefined
  if (typeof me.IsPatient === 'boolean') return me.IsPatient
  const roles = relationshipRoles(me.Relationships)
  if (!roles.length) return undefined
  return everyActiveRoleIsPatient(roles)
}; exports.isPatientMe = isPatientMe
